import { type Context, type Dispatch, type SetStateAction, createContext } from 'react';

export type ThemeMode = 'light' | 'dark' | 'system';

export type ThemeZoom = 'dense' | 'normal' | 'comfortable';

const defaultValue: {
  zoom: ThemeZoom;
  setZoom: Dispatch<SetStateAction<ThemeZoom>>;
} = {
  zoom: 'normal',
  setZoom: () => {},
};

export interface IThemeContext {
  zoom: ThemeZoom;
  setZoom: Dispatch<SetStateAction<ThemeZoom>>;
}

export const ThemeContext: Context<IThemeContext> = createContext(defaultValue);
